export default __webpack_public_path__ + "static/LobbyView_CapitolBuildingPerson-9603ae4f09b652209c458ba16b430103.png";